import throttle from 'lodash-es/throttle';

export const Helpers = (() => {
	'use strict';

	var header_height = 0;
	var first_block_height = 0;
	var is_homepage = document.querySelector('body').classList.contains('home')
	console.log('is_homepage', is_homepage)

	function init() {
		links();
		get_block_height();
		resize();
		body_scroll();
		mobile_menu();
	}

	function get_block_height() {
		header_height = document.querySelector('header.site-header').offsetHeight
		first_block_height = (document.querySelector('.pxblock')) ? document.querySelector('.pxblock').offsetHeight : 0;
	}

	function links() {
		document.querySelectorAll('a').forEach((anchorTag) => {
			// External links
			if (
				anchorTag.href.indexOf(window.location.host) < 0 &&
				anchorTag.href.indexOf('mailto') < 0 &&
				anchorTag.href.indexOf('tel') < 0
			)
				anchorTag.setAttribute('target', '_blank');

			// Anchor links
			if (anchorTag.href.indexOf('#') === 0 && !document.getElementById(anchorTag.href.replace('#', '')))
				window.scrollTo({ top: 0, behavior: 'smooth' });
		});
	}

	function resize() {
		window.addEventListener(
			'resize',
			throttle(() => {
				get_block_height();
			}, 150)
		);
	}

	function body_scroll() {
		window.addEventListener(
			'scroll',
			throttle(() => {
				// document.body.classList.toggle('scrolled', (window.scrollY > first_block_height))
				// document.body.classList.toggle('header--scrolled-out', !is_homepage || (window.scrollY >= header_height))
			}, 100)
		);
	}

	function mobile_menu() {
		const mobileTrigger = document.querySelector('.site-header__mobile-trigger');

		if (!mobileTrigger) return;

		mobileTrigger.addEventListener('click', () => {
			mobileTrigger.classList.toggle('open');
			document.body.classList.toggle('mobile-nav-open');
		});
	}

	return {
		init: init,
	};
})();
